"use strict";
// import { nBins } from '../config';
Object.defineProperty(exports, "__esModule", { value: true });
function isSurrogate(model) {
    return model.target !== undefined;
}
exports.isSurrogate = isSurrogate;



//////////////////
// WEBPACK FOOTER
// ./src/models/base.ts
// module id = 609
// module chunks = 0